export default __webpack_public_path__ + "static/media/icone_youtube.20c9ba40.svg";